var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3038 2.49737C11.9973 2.19077 11.6335 1.94756 11.233 1.78162C10.8325 1.61568 10.4033 1.53027 9.96978 1.53027C9.53629 1.53027 9.10704 1.61568 8.70657 1.78162C8.30609 1.94756 7.94223 2.19077 7.63578 2.49737L6.99978 3.13337L6.36378 2.49737C5.74476 1.87835 4.9052 1.53059 4.02978 1.53059C3.15436 1.53059 2.31479 1.87835 1.69578 2.49737C1.07676 3.11638 0.729004 3.95595 0.729004 4.83137C0.729004 5.70679 1.07676 6.54635 1.69578 7.16537L6.99978 12.4694L12.3038 7.16537C12.6104 6.85892 12.8536 6.49506 13.0195 6.09458C13.1855 5.69411 13.2709 5.26486 13.2709 4.83137C13.2709 4.39788 13.1855 3.96863 13.0195 3.56816C12.8536 3.16768 12.6104 2.80382 12.3038 2.49737Z",
    stroke: "#B3B3B3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeoff);
export default __webpack_public_path__ + "static/media/like=off.9f28adac791ef3cf4043d138fbba46d4.svg";
export { ForwardRef as ReactComponent };